import { createAsyncActionType } from '.';

export const USER_INFO_GET = createAsyncActionType('user', 'USER_INFO_GET');

export const UPDATE_EMAIL = createAsyncActionType('user', 'UPDATE_EMAIL');

export const UPDATE_PASSWORD = createAsyncActionType('user', 'UPDATE_PASSWORD');

export const UPDATE_USER_PICTURE = '@@user/UPDATE_USER_PICTURE';

export const REGION_PROVINCE_SET = createAsyncActionType(
  'user',
  'REGION_PROVINCE_SET'
);

export const REGION_PROVINCE_LIST_GET = createAsyncActionType(
  'user',
  'REGION_PROVINCE_LIST_GET'
);

export const SAVE_TEMP_TOKEN = '@@user/SAVE_TEMP_TOKEN';
